import css_img from '../assets/img/css.svg'
import html_img from '../assets/img/html.svg'
import javascript_img from '../assets/img/javascript.svg'
import typescript_img from '../assets/img/typescript.svg'
import react_img from '../assets/img/react.svg'
import bootstrap_img from '../assets/img/bootstrap.svg'
import nodejs from '../assets/img/nodejs.svg'
import npm from '../assets/img/npm.svg'
import angular from '../assets/img/angular.svg'
import mysql from '../assets/img/mysql.svg'

export const skillsData = [
    {
        img: html_img,
        name: 'HTML'
    },
    {
        img: css_img,
        name: 'CSS'
    },
    {
        img: javascript_img,
        name: 'Javascript'
    },
    {
        img: typescript_img,
        name: 'Typescript'
    },
    {
        img: react_img,
        name: 'React'
    },
    {
        img: bootstrap_img,
        name: 'Bootstrap'
    },
    {
        img: nodejs,
        name: 'nodejs'
    },
    {
        img: npm,
        name: 'Npm'
    },
    {
        img: angular,
        name: 'Angular'
    },
    {
        img: mysql,
        name: 'MySQL'
    }
]